import { useState, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import Sidebar from './components/Sidebar'
import StatusBar from './components/StatusBar'
import InstitutionsTab from './components/tables/InstitutionsTab'
import MenuCategoriesTab from './components/tables/MenuCategoriesTab'
import MenuItemsTab from './components/tables/MenuItemsTab'
import NoticesTab from './components/tables/NoticesTab'
import TeachersStaffTab from './components/tables/TeachersStaffTab'
import ImportantLinksTab from './components/tables/ImportantLinksTab'
import GalleryTab from './components/tables/GalleryTab'
import QuickButtonsTab from './components/tables/QuickButtonsTab'
import StudentStatsTab from './components/tables/StudentStatsTab'
import type { TableName, StatusMessage } from './types'

const DEFAULT_EIIN = '106501'

export default function WebAdminPanel() {
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<TableName>('institutions')
  const [status, setStatus] = useState<StatusMessage | null>(null)
  const [eiin] = useState(DEFAULT_EIIN)

  const onStatus = useCallback((msg: StatusMessage) => setStatus(msg), [])

  const tabProps = { eiin, onStatus }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fff 100%)',
      fontFamily: "'Inter', 'Hind Siliguri', system-ui, sans-serif"
    }}>
      {/* Top Header */}
      <div style={{
        background: 'linear-gradient(135deg, #ea580c 0%, #c2410c 100%)',
        color: '#fff',
        padding: '14px 28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 4px 20px rgba(234, 88, 12, 0.25)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <span style={{ fontSize: '24px', background: '#fff', padding: '6px 10px', borderRadius: '10px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>🌐</span>
          <div>
            <div style={{ fontWeight: 800, fontSize: '18px', letterSpacing: '-0.01em' }}>FGC Web Admin Panel</div>
            <div style={{ fontSize: '12px', color: 'rgba(255, 247, 237, 0.9)' }}>
              ফেনী সরকারি কলেজ · ☁️ Database
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{
            background: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(4px)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            color: '#fff',
            fontSize: '12px',
            fontWeight: 700,
            padding: '5px 12px',
            borderRadius: '8px'
          }}>
            ☁️ Database Connected
          </span>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              padding: '7px 16px',
              background: '#fff',
              border: 'none',
              borderRadius: '8px',
              color: '#ea580c',
              fontSize: '13px',
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
            }}
          >
            ← Dashboard
          </button>
        </div>
      </div>

      {/* Body */}
      <div style={{ display: 'flex', gap: '24px', padding: '24px', maxWidth: '1440px', margin: '0 auto' }}>
        {/* Sidebar */}
        <Sidebar activeTab={activeTab} onTabChange={setActiveTab} eiin={eiin} />

        {/* Main Content */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <StatusBar message={status} onClear={() => setStatus(null)} />
          <div style={{
            background: '#fff',
            borderRadius: '16px',
            padding: '28px',
            border: '1px solid #fed7aa',
            boxShadow: '0 10px 30px rgba(234, 88, 12, 0.05)',
            minHeight: '75vh'
          }}>
            {activeTab === 'institutions' && <InstitutionsTab onStatus={onStatus} />}
            {activeTab === 'menu_categories' && <MenuCategoriesTab onStatus={onStatus} />}
            {activeTab === 'menu_items' && <MenuItemsTab {...tabProps} />}
            {activeTab === 'notices' && <NoticesTab {...tabProps} />}
            {activeTab === 'teachers_staff' && <TeachersStaffTab {...tabProps} />}
            {activeTab === 'important_links' && <ImportantLinksTab {...tabProps} />}
            {activeTab === 'gallery' && <GalleryTab {...tabProps} />}
            {activeTab === 'quick_buttons' && <QuickButtonsTab {...tabProps} />}
            {activeTab === 'student_stats' && <StudentStatsTab {...tabProps} />}
          </div>
        </div>
      </div>
    </div>
  )
}
